export enum AuthEvent {
  SignIn = "auth_sign_in",
  SignUp = "auth_sign_up",
  ConfirmSignUp = "auth_confirm_sign_up",
  ForceNewPassword = "auth_force_new_password",
  ForgotPassword = "auth_forgot_password",
  ConfirmResetPassword = "auth_confirm_reset_password",
  SignOut = "auth_sign_out",
  Authenticated = "auth_authenticated",
}

export const AUTH_ROUTE_TO_EVENT: Record<string, AuthEvent> = {
  signIn: AuthEvent.SignIn,
  signUp: AuthEvent.SignUp,
  confirmSignUp: AuthEvent.ConfirmSignUp,
  forceNewPassword: AuthEvent.ForceNewPassword,
  forgotPassword: AuthEvent.ForgotPassword,
  confirmResetPassword: AuthEvent.ConfirmResetPassword,
  signOut: AuthEvent.SignOut,
  authenticated: AuthEvent.Authenticated,
};
